/**
 * @description 是否 mobile 格式
 * @param {String} string
 * @returns {Boolean}
 */
export const formatCellphone = (string: string): boolean => /^(13|14|15|16|17|18|19)[0-9]{9}$/.test(String(string))
